<template>
  <v-row class="py-3" no-gutters>
    <integration-summary :data="gateway" />

    <v-col cols="8">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="ml-n1 subtitle-1 text--secondary font-weight-medium">
            <router-link :to="{ name: 'Integrations' }" class="subtitle-1 routerLink font-weight-medium">Integraciones</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>2Checkout
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background overflow-y-auto" style="height: calc(100vh - 238px)">
          <!-- loader -->
          <v-row v-if="$store.state.payments.retrieveLoader" no-gutters>
            <v-col>
              <v-skeleton-loader type="article, actions" />
            </v-col>
          </v-row>
          <!-- end loader -->

          <!-- installed diagram -->
          <integration-installed v-else-if="installed.includes('twocheckout')" integration="twocheckout" />
          <!-- end installed diagram -->

          <!-- connection -->
          <v-row v-else no-gutters>
            <v-col cols="10">
              <span class="d-block pt-6 px-5 text--secondary subtitle-1 font-weight-medium">Checkout</span>
              <span class="d-block px-5 background text--primary">Utiliza las credenciales obtenidas desde 2checkout.com para el producto <span class="text--secondary font-weight-medium">Checkout</span></span>

              <v-list class="py-3" color="background" dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Commerce code</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="6" class="pa-0">
                        <v-text-field v-model="$v.provider.commerce_code.$model" :error="$v.provider.commerce_code.$error" background-color="white" outlined :placeholder="gateway.placeholder" required single-line dense maxlength="254" hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Secret key</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="4" class="pa-0">
                        <v-text-field v-model="$v.provider.extra_data.secret.$model" :error="$v.provider.extra_data.secret.$error" background-color="white" outlined required single-line dense hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <!-- end connection -->
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn v-if="installed.includes('twocheckout')" @click="destroyProvider('twocheckout')" dark color="red">Desconectar</v-btn>
          <v-btn v-else @click="createProvider(provider)" :loading="loaderConnect" color="primary">Conectar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
// libs & utils
import { required, maxLength } from 'vuelidate/lib/validators'
import gateways from '@/collections/gateways'

// components
import IntegrationInstalled from '@/components/integrations/Installed'
import IntegrationSummary from '@/components/integrations/Summary'

// mixins
import IntegrationViewMixin from '@/mixins/IntegrationViewMixin'

export default {
  components: {
    IntegrationInstalled,
    IntegrationSummary
  },
  mixins: [
    IntegrationViewMixin
  ],
  data: () => ({
    gateway: gateways.find(gateway => gateway.id === 'twocheckout'),
    provider: {
      gateway: 'twocheckout',
      commerce_code: '',
      extra_data: {
        secret: ''
      }
    }
  }),
  created () {
    this.retrieveProvider('twocheckout')
  },
  validations: {
    provider: {
      gateway: {
        required
      },
      commerce_code: {
        required,
        maxLength: maxLength(254)
      },
      extra_data: {
        secret: {
          required,
          maxLength: maxLength(254)
        }
      }
    }
  }
}
</script>